
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/converter/xd-to-powerpoint",
      function () {
        return require("private-next-pages/converter/xd-to-powerpoint.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/converter/xd-to-powerpoint"])
      });
    }
  